import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import useFetchLearningGoalData from 'bundles/onboarding-common/hooks/useFetchLearningGoalData';
import useFetchUserIdAndExternalId from 'bundles/onboarding-common/hooks/useFetchUserIdAndExternalId';
import useSaveLocalStorageOnboardingToLearnerObject from 'bundles/onboarding-common/hooks/useSaveLocalStorageOnboardingToLearnerObject';
import { getLocalStorageOnboardingData } from 'bundles/onboarding-common/utils/localStorageUtils';

const useSaveOnboardingOnSignup = () => {
  const { saveLocalStorageOnboardingToLearnerObject } = useSaveLocalStorageOnboardingToLearnerObject();
  const { fetchUserIdAndExternalId } = useFetchUserIdAndExternalId();
  const { fetchLearningGoalData } = useFetchLearningGoalData();

  const saveOnboardingOnSignup = async () => {
    let hasSavedOnboardingDataAfterSignup = false;
    // Check if there is localStorage data, if not, don't do anything
    const localStorageData = getLocalStorageOnboardingData();
    if (!localStorageData || !localStorageData[QUESTION_IDS.learningGoal]?.value) {
      return hasSavedOnboardingDataAfterSignup;
    }

    // Check if there is already a learning goal saved
    // If so, don't save again until we can show the warning modal on LIHP
    const learningGoalData = await fetchLearningGoalData();
    if (learningGoalData) {
      return hasSavedOnboardingDataAfterSignup;
    }

    // Get the userId and externalId needed to save the data
    const userData = await fetchUserIdAndExternalId();

    if (!userData) {
      // This is an error state, but we don't want to block the user
      return hasSavedOnboardingDataAfterSignup;
    }

    const { userId, externalId } = userData;

    await saveLocalStorageOnboardingToLearnerObject(localStorageData, userId, externalId);
    hasSavedOnboardingDataAfterSignup = true;
    return hasSavedOnboardingDataAfterSignup;
  };

  return { saveOnboardingOnSignup };
};

export default useSaveOnboardingOnSignup;
